export default __webpack_public_path__ + "static/media/checkbox.d8079d71.svg";